/**
 * <PDFAttachment> — the picked-document preview card (molecule, L0.1).
 *
 * One of the three focused attachment previews (with `<ImageAttachment>` / `<LinkAttachment>`). A tinted
 * `<Card>` with a title and a single row: a file glyph, the file name, and a trash affordance. Tapping the
 * card fires `onOpen` (open the viewer).
 */
import React from "react"
import { StyleSheet } from "react-native-unistyles"

import { Card } from "../Card"
import { IconButton } from "../../atoms/Buttons/IconButton"
import { Icon } from "../../atoms/icons/Icon"
import { Row } from "../../atoms/containers/Row"
import { Stack } from "../../atoms/containers/Stack"
import { Text } from "../../atoms/typography/Text"

export type PDFAttachmentProps = {
    /** File name shown next to the icon — defaults to "Document PDF". */
    name?: string
    onDelete: () => void
    onOpen?: () => void
    testID?: string
}

export function PDFAttachment(props: PDFAttachmentProps) {
    const { name, onDelete, onOpen, testID } = props

    return (
        <Card background="primary-soft" p="5" pressable={onOpen != null} onPress={onOpen} testID={testID}>
            <Stack gap="3">
                <Text size="text-lg" weight="bold" color="primary">
                    PDF
                </Text>
                <Row gap="2" align="center">
                    <Icon name="file-pdf" color="primary" />
                    <Text numberOfLines={1} style={styles.grow}>
                        {name ?? "Document PDF"}
                    </Text>
                    <IconButton
                        iconName="trash"
                        color="danger"
                        size={28}
                        iconSize={13}
                        onPress={onDelete}
                        accessibilityLabel="Supprimer"
                    />
                </Row>
            </Stack>
        </Card>
    )
}

const styles = StyleSheet.create(() => ({
    grow: {
        flex: 1,
    },
}))
